import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faNewspaper, faClock, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import indIcon from "../../assets/Ind.png";
import bikeImage from "../../assets/bike.png";
import styles from "./DrivingLicenseRenewal.module.css";
import DrivingLicenseRenewalForm from "./DrivingLicenseRenewalForm";
import HireRiderSection from "./HireRiderSection";
import PaymentDetails from "./PaymentDetails";

// Mock news data - all related to Driving License Renewal
const newsData = [
  {
    id: 1,
    title: "Driving License Renewal Made Easier",
    subtitle: "New online portal reduces renewal time to just 15 minutes",
    category: "License Updates",
    time: "2 hours ago",
    image: "🆔",
    gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    priority: "high"
  },
  {
    id: 2,
    title: "Extended Validity Period for Renewed Licenses",
    subtitle: "Renewed driving licenses now valid for 20 years instead of 15",
    category: "Policy Changes",
    time: "5 hours ago",
    image: "📅",
    gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
    priority: "high"
  },
  {
    id: 3,
    title: "No More Physical Documents Required",
    subtitle: "Upload documents digitally for hassle-free license renewal",
    category: "Digital Updates",
    time: "1 day ago",
    image: "📱",
    gradient: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
    priority: "medium"
  },
  {
    id: 4,
    title: "Reduced Renewal Fees Announced",
    subtitle: "Government cuts driving license renewal fees by 30% nationwide",
    category: "Fee Updates",
    time: "2 days ago",
    image: "💰",
    gradient: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
    priority: "medium"
  },
  {
    id: 5,
    title: "Grace Period for Expired Licenses",
    subtitle: "6-month grace period introduced for expired license renewals",
    category: "Renewal Benefits",
    time: "3 days ago",
    image: "⏰",
    gradient: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
    priority: "medium"
  },
  {
    id: 6,
    title: "Instant License Delivery Service",
    subtitle: "Get your renewed license delivered to your doorstep within 48 hours",
    category: "Delivery Services",
    time: "4 days ago",
    image: "🚚",
    gradient: "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)",
    priority: "low"
  },
  {
    id: 7,
    title: "Medical Certificate Now Optional",
    subtitle: "Medical fitness certificate waived for license renewals under age 50",
    category: "Document Updates",
    time: "5 days ago",
    image: "🏥",
    gradient: "linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)",
    priority: "medium"
  },
  {
    id: 8,
    title: "Biometric Update Not Required",
    subtitle: "Existing biometric data will be used for license renewal process",
    category: "Process Updates",
    time: "1 week ago",
    image: "👆",
    gradient: "linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)",
    priority: "low"
  }
];

function NewsWidget() {
  const [currentNewsIndex, setCurrentNewsIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  // Change news daily based on date
  useEffect(() => {
    const today = new Date();
    const dayOfYear = Math.floor((today - new Date(today.getFullYear(), 0, 0)) / 1000 / 60 / 60 / 24);
    setCurrentNewsIndex(dayOfYear % newsData.length);
  }, []);

  // Auto-rotate news every 10 seconds for demo (remove in production)
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentNewsIndex((prev) => (prev + 1) % newsData.length);
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  const currentNews = newsData[currentNewsIndex];

  const handleNewsClick = () => {
    // Handle news item click - could open detailed view
    console.log("News clicked:", currentNews);
  };

  return (
    <div className={styles.newsWidget} onClick={handleNewsClick}>
      <div 
        className={styles.newsCard}
        style={{ background: currentNews.gradient }}
      >
        <div className={styles.newsHeader}>
          <div className={styles.newsIcon}>
            <FontAwesomeIcon icon={faNewspaper} />
          </div>
          <div className={styles.newsTime}>
            <FontAwesomeIcon icon={faClock} />
            <span>{currentNews.time}</span>
          </div>
        </div>
        
        <div className={styles.newsContent}>
          <div className={styles.newsEmoji}>{currentNews.image}</div>
          <div className={styles.newsText}>
            <div className={styles.newsCategory}>{currentNews.category}</div>
            <h3 className={styles.newsTitle}>{currentNews.title}</h3>
            <p className={styles.newsSubtitle}>{currentNews.subtitle}</p>
          </div>
        </div>
        
        <div className={styles.newsFooter}>
          <div className={styles.priorityIndicator}>
            <div className={`${styles.priorityDot} ${styles[currentNews.priority]}`}></div>
            <span className={styles.priorityText}>
              {currentNews.priority.charAt(0).toUpperCase() + currentNews.priority.slice(1)} Priority
            </span>
          </div>
          <FontAwesomeIcon icon={faArrowRight} className={styles.arrowIcon} />
        </div>
      </div>
      
      <div className={styles.newsIndicators}>
        {newsData.map((_, index) => (
          <div 
            key={index}
            className={`${styles.indicator} ${index === currentNewsIndex ? styles.active : ''}`}
          />
        ))}
      </div>
    </div>
  );
}

function DrivingLicenseRenewal() {
  return (
    <div className={styles.mainContainer}>
      <div className={styles.container}>
        <div className={styles.leftContent}>
          <NewsWidget />
        </div>
        <div>
          <img src={bikeImage} alt="Vehicle" className={styles.vehicleImage} />
        </div>
      </div>
      <DrivingLicenseRenewalForm />
      {/* <HireRiderSection />
      <PaymentDetails /> */}
    </div>
  );
}

export default DrivingLicenseRenewal;